import { onUpdated, ref } from 'vue'

// TinyMCE imports
import "tinymce/tinymce"
import "tinymce/themes/silver";
import "tinymce/icons/default";
import 'tinymce/models/dom/model'
import 'tinymce/skins/ui/oxide/skin.css';
// TinyMCE plugin imports
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/autolink';

import Editor from '@tinymce/tinymce-vue'

export default {
    name: "TextEditor",
    components: {
        Editor
    },
    props: {
        initContent: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const content = ref(props.initContent)

        return {
            content
        }
    }
}